import React from "react";
import { RadioGroup, Typography, FormControlLabel, Radio } from "@material-ui/core";

import "../styles/PreguntasSeguridad.scss";

class PreguntaComponent extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      respuesta: "",
    };
  }

  componentDidMount = () => {
    this.setState({
      respuesta: "",
    });
  };

  handleRespuesta = (event) => {
    this.setState({ respuesta: event.target.value });
    this.props.handleChange(this.props.pregunta, event.target.value);
  };

  render() {
    const preg = this.props.pregunta;
    return (
      <div className="contenedorPreguntaIndividual">
        <div className="titulopregunta">
          <Typography>{preg.pregunta}</Typography>
        </div>
        <RadioGroup key={preg.id} id="radioGrupo" value={this.state.respuesta} onChange={this.handleRespuesta}>
          {preg.alternativas.map((al) => (
            <FormControlLabel key={al.codigo} value={al.codigo} control={<Radio color="primary" />} label={al.respuesta} defaultChecked={false} />
          ))}
        </RadioGroup>
      </div>
    );
  }
}

export default PreguntaComponent;
